import Button from '@zenbusiness/common-components/Button';
import Caption from '@zenbusiness/common-components/Caption';
import Text from '@zenbusiness/common-components/Text';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import superstyled from '#client/pages/EducationStudio/utils/superstyled';

export const LessonDescContainer = superstyled(
  {
    name: 'LessonDescContainer',
    slot: 'LessonDescContainer',
    propsNeeded: ['isPreview'],
    tag: Box,
    styles: ({ theme, isPreview }) => {
      const isPreviewStylesMdUp = isPreview ? {
        display: 'flex',
        maxWidth: 'inherit',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '2rem'
      } : '';

      return {
        backgroundColor: theme.palette.focus90.main,
        padding: isPreview ? '2.5rem 1.5rem 5.5rem' : '2rem',
        width: '100%',
        height: 'fit-content',
        [theme.breakpoints.up('md')]: {
          padding: '2rem',
          borderRadius: '1.5rem',
          ...isPreviewStylesMdUp
        }
      };
    }
  }
);

export const LessonDescTextContainer = superstyled({
  tag: Box,
  styles: ({ theme }) => ({
    marginBottom: '0rem',
    [theme.breakpoints.up('md')]: {
      marginBottom: '1.5rem'
    }
  })
});

export const PreviewDescription = superstyled({
  tag: Text,
  props: { size: 'md' },
  propsNeeded: ['secondaryColor'],
  styles: ({ theme, secondaryColor }) => ({
    ...theme.typography.title_huge,
    color: secondaryColor,
    '&.MuiTypography-root': {
      marginTop: '0.625rem'
    },
    [theme.breakpoints.up('md')]: {
      ...theme.typography.title_largeAlt
    }
  })
});

export const LessonDescArticle = superstyled({
  tag: Caption,
  props: { size: 'md', bold: true, color: 'focus10' },
  propsNeeded: ['isPreview'],
  styles: ({ isPreview }) => ({
    textTransform: 'uppercase',
    display: isPreview ? 'none' : 'block',
    '&.MuiTypography-root': {
      marginBottom: '0.625rem'
    }
  })
});

export const PreviewTitle = superstyled({
  tag: Text,
  props: { size: 'sm' },
  name: 'PreviewTitle',
  styles: ({ theme }) => ({
    ...theme.typography.body_smallRegular,
    color: theme.palette.focus10.main,
    textTransform: 'uppercase'
  })
});

export const LessonDescTitle = superstyled({
  tag: Text,
  props: { size: 'sm', color: 'focus10' },
  name: 'LessonDescTitle',
  propsNeeded: ['secondaryColor'],
  styles: ({ theme, secondaryColor }) => ({
    ...theme.typography.title_huge,
    color: secondaryColor,
    [theme.breakpoints.up('md')]: {
      ...theme.typography.title_mediumAlt
    }
  })
});

export const LessonDescDescription = superstyled({
  tag: Text,
  styles: ({ theme }) => ({
    color: theme.palette.focus10.main,
    fontWeight: 'bold',
    '&.MuiTypography-root': {
      marginTop: '1rem'
    }
  })
});

/* [EDU] TODO: Fix container to make buttons appear in row instead of stacked */
export const LessonDescButtonsContainer = superstyled({
  tag: Grid,
  props: {
    variant: 'contained',
    color: 'primary',
    size: 'large'
  },
  styles: () => ({
    marginLeft: '0.5rem',
    maxWidth: '21rem',
    gap: '1rem',
    justifyContent: 'flex-end'
  })
});

export const LessonButtons = superstyled({
  tag: Button,
  props: { size: 'large' },
  name: 'Next',
  styles: () => ({
    padding: '1.25rem 1.5rem',
    borderRadius: '1rem',
    textTransform: 'none'
  })
});

export const WatchVideoButton = superstyled({
  tag: Button,
  props: { size: 'large' },
  styles: () => ({
    padding: '1.25rem 1.5rem',
    borderRadius: '1rem',
    textTransform: 'none'
  })
});

export const NextButton = superstyled({
  tag: Button,
  name: 'Next',
  props: { size: 'large' },
  styles: () => ({
    padding: '1.25rem 1.5rem',
    borderRadius: '1rem',
    textTransform: 'none'
  })
});
